module.exports = __webpack_public_path__ + "static/media/flowers_16.c6f74ec6.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/flowers/flowers_16.csv
// module id = 755
// module chunks = 0